import './index.sass';
import Backbone from 'backbone/backbone-min';
import autosize from 'autosize';
import {initTooltip} from '~/blocks/tooltip';
import initEmoji from '~/pages/dialog_members/inputEmoji';

export default () => {
  let Comment, Comments, CommentsBlock;

  if ($('#comments').length === 0) {
    return;
  }
  function preloadingOverlayShow() {
    $('.preloader').addClass('preloader--show');
    $('body').addClass('no-scroll');
  }

  function preloadingOverlayHide() {
    $('.preloader').removeClass('preloader--show');
    $('body').removeClass('no-scroll');
  }

  function initPhotoFileUpload(form_selector) {
    const $form = form_selector
    const url = $form.data('photo-url');
    $form.each((idx, form) => {
      $(form).find('.comment-form__file').fileupload({
        url: url,
        dropZone: null,
        type: 'POST',
        headers: {
          "X-CSRF-Token": $('meta[name=csrf-token]').attr('content'),
        },
        formData: {},
        singleFileUploads: false,
        multipart: true,
        start: function () {
          preloadingOverlayShow();
        },
        done: function (e, data) {
          if (data.result.errors) {
            preloadingOverlayHide();
            alert(data.result.errors);
            return;
          }
          var $ImagesList = $(form).find('.comment-form__previews');
          $ImagesList.append(data.result.photos);
          $ImagesList.parent().show();
          $('.message-comment-form .button-casual').removeClass('disabled').removeAttr('disabled');
          preloadingOverlayHide();
        },
        fail: function () {
          preloadingOverlayHide();
        }
      });

    })
  }
  initPhotoFileUpload($('.js-send-message-form'));

  autosize($('.comment-textarea'));
  Comment = Backbone.Model.extend({
    initialize: function() {
      return this.set('comments', new Comments(this.get('comments')));
    },
    elementSelector: function() {
      return '.comment[data-comment-id="' + this.get('id') + '"]';
    },
    lastChildComment: function() {
      let lastChild;
      lastChild = this;
      while (lastChild.get('comments').length > 0) {
        lastChild = lastChild.get('comments').last();
      }
      return lastChild;
    }
  });
  Comments = Backbone.Collection.extend({
    model: Comment,
    findById: function(id) {
      let result;
      result = null;
      this.forEach(function(comment) {
        let child;
        if (comment.id === id) {
          return result = comment;
        } else {
          child = comment.get('comments').findById(id);
          if (child) {
            return result = child;
          }
        }
      });
      return result;
    },
    removeById: function(id) {
      let result, self;
      self = this;
      result = null;
      this.each(function(comment) {
        let child;
        if(comment) {
          if (comment.id === id) {
            result = comment;
            self.remove(comment);
          }
          child = comment.get('comments').removeById(id);
          if (child) {
            return result = child;
          }
        }
      });
      return result;
    },
    size: function() {
      return this.reduce(function(memo, comment) {
        return memo + 1 + comment.get('comments').size();
      }, 0);
    }
  });
  CommentsBlock = Backbone.View.extend({
    el: $('#comments'),
    events: {
      'ajax:send .comment__edit,.js-answer-comment,.comment__remove': 'beforeCommentAction',
      'ajax:success form.new-comment': 'commentAdded',
      'ajax:success form.edit-comment': 'commentUpdated',
      'ajax:success .comment__remove': 'commentRemoved',
      'ajax:success .comment__edit': 'commentEdited',
      'keyup [data-comment-form] .comment-textarea': 'commentBodyChanged',
      'click .js-comment-show': 'loadComments',
      'click #scroll_to_comment': 'scrollToComment',
      'click .reset-comment-btn': 'resetForm',
      'ajax:error': 'serverError',
      'ajax:success .js-answer-comment': 'commentCreated',
      'ajax:success .like-increase,.like-decrease': 'commentVoted',
      // 'click .comment-form__submit': 'submitForm'
    },
    initialize: function(comments) {
      return this.comments = new Comments(comments);
    },
    submitForm: function(e) {
      let linkAdd;
      const $textarea = $('.comment-textarea');
      const $string = $textarea.val();
      // const $string = 'sdfsdfsdfsdfsdfds sdfffffffffff/\\rsdfffffffffffff sdffffffffffff';
      // const splitString = $string.split(/\r|\n/);
      const splitString = $string.split(/\r|\n|\s/);
      console.log(splitString);
      // var regExp = /^(ftp|http|https):\/\/[^ "]+$/;
      var regExp = new RegExp("^(http|https|ftp)\://([a-zA-Z0-9\.\-]+(\:[a-zA-Z0-9\.&amp;%\$\-]+)*@)*((25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9])\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[0-9])|([a-zA-Z0-9\-]+\.)*[a-zA-Z0-9\-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(\:[0-9]+)*(/($|[a-zA-Z0-9\.\,\?\'\\\+&amp;%\$#\=~_\-]+))*$");
      splitString.forEach((item,i) => {
        if(regExp.test(item)) {
          const nameLink = function() {
            if(item.length > 53) {
              return item.substr(0, 53) + '...'
            } else {
              return item
            }
          }()
          linkAdd = `<a href=${item}>${nameLink}</a>`
          delete splitString[i]
          splitString.push(linkAdd)
        }
      })
      // $textarea.val(splitString.join(' ')).css('height','45');
      setTimeout(() => {
        $('.new-comment:not(.comment--reply-second, .comment--reply) .comment-form__input').val('');
      })
    },
    beforeCommentAction: function() {
      let alreadyOpenedForms;
      alreadyOpenedForms = this.$el.find('.comment-form:not([data-comment-form])');
      return alreadyOpenedForms.animate({
        height: 'toggle',
        opacity: 'toggle'
      }, 'fast', function() {
        return this.remove();
      });
    },
    loadComments: function(e) {
      e.preventDefault();
      const url = $(e.currentTarget).attr('href');
      const $btn = $('.js-comment-show');
      $.ajax({
        url: url,
        headers: {"X-CSRF-Token": $('meta[name=csrf-token]').attr('content')},
        contentType: 'application/json',
        success(data) {
          $btn.attr('href', data.url);
          $btn.before(data.illustrations);
          if(data.last_page) {
            $btn.remove();
          }
        }
      });
    },
    commentCreated: function(e) {
      const data = e.detail[0];
      let comment, commentBlock, commentId, form, lastChildComment;
      form = $(data.html).hide();
      commentBlock = $(e.target).closest('.comment');
      commentId = commentBlock.data('comment-id');
      comment = this.comments.findById(commentId);
      lastChildComment = comment.lastChildComment();
      $(lastChildComment.elementSelector()).after(form);
      initTooltip();
      initPhotoFileUpload($('.js-send-message-form'));
      form.find('.comment-form__input').emoji();
      autosize($('.comment-textarea'));
      return form.animate({
        height: 'toggle',
        opacity: 'toggle'
      }, 'fast', (function(_this) {
        return function() {
          return _this.doScrollToComment(form);
        };
      })(this));
    },
    commentAdded: function(e) {
      const data = e.detail[0];
      let comment, formWrapper, newComment, parentComment;
      if (data.error) {
        return showError(data.error);
      } else if (data.premium_error) {
        return showError(data.premium_error, '#modal-premium-error');
      } else {
        newComment = $(data.html).hide();
        formWrapper = $(e.target).closest('.comment-form');
        $(formWrapper).before(newComment);
        newComment.animate({
          height: 'toggle',
          opacity: 'toggle'
        }, 'fast');
        if (data.parent_id) {
          formWrapper.remove();
        } else {
          formWrapper.find('.comment-textarea').val('');
          formWrapper.find('.reset-comment-btn').hide();
          formWrapper.find('.comment-form__previews').empty();
        }
        comment = new Comment({
          id: data.comment_id
        });
        if (data.parent_id) {
          parentComment = this.comments.findById(data.parent_id);
          parentComment.get('comments').add(comment);
        } else {
          const lastChildComment = comment.lastChildComment();
          const $btn = $('.js-comment-show');
          const url = $btn.attr('href');
          this.comments.add(comment);
          if($btn.length) {
            const btn = `<a href='${url}' class='illustration-comments__show-more js-comment-show'>Показать еще</a>`
            $btn.remove();
            $(lastChildComment.elementSelector()).after(btn);
          }
        }
        this.updateCommentsCount();
        return this.updateLeftResponsesText(data);
      }
    },
    commentRemoved: function(e, data) {
      let comment, elements2Remove;
      // if (data.redirectTo) {
      //   window.location.replace(data.redirectTo);
      //   return;
      // }
      comment = this.comments.removeById(e.detail[0].comment_id);
      elements2Remove = this.commentElements(comment);
      elements2Remove.animate({
        height: 'toggle',
        opacity: 'toggle'
      }, 'fast', function() {
        return this.remove();
      });
      return this.updateCommentsCount();
    },
    commentElements: function(comment) {
      let elements, self;
      self = this;
      elements = this.$el.find(comment.elementSelector());
      comment.get('comments').each(function(child) {
        return elements = elements.add(self.commentElements(child));
      });
      return elements;
    },
    commentEdited: function(e, data) {
      let form;
      // if (data) {
      //   window.location.replace(data.redirectTo);
      //   return;
      // }
      form = $(e.detail[0].html).hide();
      form.find('.comment-form__previews').append(e.detail[0].photos);
      $(e.target).closest('.comment').after(form);
      initPhotoFileUpload(form.find('form'));
      return form.animate({
        height: 'toggle',
        opacity: 'toggle'
      }, 'fast', (function(_this) {
        return function() {
          autosize(form.find('.comment-textarea'));
          return _this.doScrollToComment(form);
        };
      })(this));
    },
    commentUpdated: function(e) {
      const data = e.detail[0];
      let comment, commentBody, formWrapper;
      if (data.error) {
        return showError(data.error);
      } else if (data.premium_error) {
        return showError(data.premium_error, '#modal-premium-error');
      } else {
        commentBody = $(data.html).hide();
        formWrapper = $(e.target).closest('.comment-form');
        formWrapper.remove();
        comment = this.comments.findById(commentBody.data('comment-id'));
        $(comment.elementSelector()).replaceWith(commentBody);
        return commentBody.animate({
          height: 'toggle',
          opacity: 'toggle'
        }, 'fast');
      }
    },
    updateCommentsCount: function() {
      let commentsTitle, count;
      count = this.comments.size();
      commentsTitle = this.$el.find('.js-title');
      if (count === 0) {
        return commentsTitle.find('.js-title-count').remove();
      } else {
        if (commentsTitle.find('.js-title-count').length === 0) {
          return commentsTitle.append('<span class="js-title-count">' + count + '</span>');
        } else {
          return commentsTitle.find('.js-title-count').text(count);
        }
      }
    },
    updateLeftResponsesText: function(data) {
      if (data.left_responses_text) {
        $('.comment-form__text--mobile').html(data.left_responses_text);
      }
      if (data.ended_responses_form) {
        return $('.new-comment').replaceWith(data.ended_responses_form);
      }
    },
    commentBodyChanged: function(e) {
      let commentBodyInput;
      commentBodyInput = $(e.target);
      // if (commentBodyInput.val().length > 1) {
      //   return commentBodyInput.parents('.comment-form').find('.button-link').show();
      // } else {
      //   return commentBodyInput.parents('.comment-form').find('.button-link').hide();
      // }
    },
    scrollToComment: function() {
      let formWrapper;
      formWrapper = this.$el.find('.comment-form').last();
      return this.doScrollToComment(formWrapper);
    },
    doScrollToComment: function(form) {
      let formOffset, offset;
      formOffset = form.offset().top;
      offset = formOffset - $(window).scrollTop();
      if (offset > window.innerHeight) {
        $('body, html').animate({
          scrollTop: formOffset - 70
        }, 300);
      }
      return form.find('.comment-textarea').focus();
    },
    resetForm: function(e) {
      let button, commentFormBlock;
      button = $(e.target);
      commentFormBlock = button.closest('.comment-form');
      if (commentFormBlock.data('comment-form')) {
        button.closest('form')[0].reset();
        return button.hide();
      } else {
        return commentFormBlock.animate({
          height: 'toggle',
          opacity: 'toggle'
        }, 'fast', function() {
          return this.remove();
        });
      }
    },
    commentVoted: function(e) {
      const data = e.detail[0];
      const handleClass = (remove, add) => {
        $(e.target).closest('.count').find('.count__info').removeClass(`count__info--${remove}`).addClass(`count__info--${add}`);
      }

      if (data.error) {
        return showError(data.error);
      } else if (data.premium_error) {
        return showError(data.premium_error, '#modal-premium-error');
      } else {
        if(data.score < 0) {
          handleClass('green', 'red');
        } else if(data.score > 0) {
          handleClass('red', 'green');
        }
        return $(e.target).closest('.count').find('.count__info').text(data.score);
      }
    },
    serverError: function() {
      return showError(I18n.t('server_error'));
    }
  });

  Window.commentsView = new CommentsBlock(gon.comments);
  return Window.Comments = Comments;
}
